<template>
  <BasicLayout :id="'five'">
    <p class="-big">
      后半年，
      <br />
      <b>好像没有什么了唉</b>
    </p>
    <li>开学</li>
    <li>上课</li>
    <li>日常</li>
    <p>哎，我已经大二了，时间可过得真快，啥都没干就应经老了。</p>
    <p>哦，对了，我开发了一套自主UI。应用于「Moment」</p>

    <img src="./../../assets/20191119152019.png" alt />
  </BasicLayout>
</template>

<script>
import BasicLayout from '../BasicLayout'
export default {
  components: {
    BasicLayout
  }
}
</script>
